import { ThunkType } from "../../../../core/store/reducers";
import { getDeliveryExcel } from "../api/getDeliverysExcel";
import fileDownload from "js-file-download";
import { setFetchState } from "../deliveryDataSlice";

export const downloadDeliveryExcel = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.clearing.deliveries;
  const user = store.data.auth.current.user;

  dispatch(setFetchState({ type: "started" }));
  const dailyTrading = await dispatch(getDeliveryExcel(user, filter));
  if (dailyTrading) {
    fileDownload(
      new Blob([dailyTrading as any], {
        type: "application/vnd.openxmlformat",
      }),
      "Delivery.xlsx"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};
